import { ACTIVATE, DEACTIVATE } from './actions';
import { tracked } from 'shared/utils/sagaWrappers';
import formSaga from './components/Form/sagas';

export default tracked(formSaga, ACTIVATE, DEACTIVATE);
